import { useCallback } from "react";
import type { Command } from "../../core";
import { useRuntime } from "../runtime/RuntimeContext";

// Dispatch an intent to the central CommandManager from anywhere.
export function useCommand(): (command: Command) => Promise<unknown> {
    const runtime = useRuntime();
    return useCallback((command: Command) => runtime.commandBus.dispatch(command), [runtime]);
}
